import { render, staticRenderFns } from "./PrepInstructorsSelectbox.vue?vue&type=template&id=60b0474e"
import script from "./PrepInstructorsSelectbox.vue?vue&type=script&lang=js"
export * from "./PrepInstructorsSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports